/*
 * Next-step prompts: right after you make a client or a job, its page offers the usual next thing once.
 * Kept in memory only, so it shows on the page you land on and never again after you close it or reload.
 */
import { useState, type ReactNode } from "react";
import { IconButton } from "./parts";

const fresh = new Set<string>();

/** Call before going to the new record's page, with "client:<id>" or "job:<id>". */
export function markFresh(key: string): void {
  fresh.add(key);
}

export function NextStep({ freshKey, title, children }: { freshKey: string; title: string; children: ReactNode }) {
  const [on, setOn] = useState(() => fresh.has(freshKey));
  if (!on) return null;
  const close = () => {
    fresh.delete(freshKey);
    setOn(false);
  };
  return (
    <div className="next-step" role="status">
      <div>
        <b>{title}</b>
        <div className="row">{children}</div>
      </div>
      <IconButton icon="close" label="Close" onClick={close} />
    </div>
  );
}
